module.exports = __webpack_public_path__ + "img/thjf.3642551f.jpg";